import type { CardInput, IVaultProvider } from '../types';

/**
 * PCI Vault provider — captura cartão no pcivault.io.
 * Roda no frontend (browser), usa capture endpoint público (URL completa + secret).
 * A URL completa vem do backend via /vault/{provider}/prepare.
 */
export class PciVaultProvider implements IVaultProvider {
  readonly name = 'pcivault';

  constructor(
    private readonly captureUrl: string,
    private readonly captureSecret: string,
  ) {}

  async capture(card: CardInput): Promise<{ token: string }> {
    const [month, year] = card.expiration.split('/');

    const response = await fetch(`${this.captureUrl}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-PCIVault-Capture-Secret': this.captureSecret,
      },
      body: JSON.stringify({
        card_number: card.number.replace(/\s/g, ''),
        card_holder: card.holder,
        card_document: card.document,
        cvv: card.cvv,
        expiry_month: +month,
        expiry_year_full: +(year.length === 2 ? `20${year}` : year),
        expiry_year: +(year.length === 2 ? year : year.slice(-2)),
      }),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`PCI Vault capture failed (${response.status}): ${text}`);
    }

    const data = (await response.json()) as { user: string; token: string; reference: string };

    // Encode token + reference juntos (ambos necessários para proxy/decrypt)
    return {
      token: JSON.stringify({ token: data.token, reference: data.reference, user: data.user }),
    };
  }
}
